import theme from "@config/theme";
import OpenSupportWidget from "@adapters/ZendeskSupportWidget";

const FeedbackFooter = () => (
  <>
    <div className="floatfollower" />
    <div className="feedback-footer">
      <span className="feedback-link">
        Can we improve this page?{" "}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          role="button"
          onClick={OpenSupportWidget}
          tabIndex={0}
          onKeyDown={OpenSupportWidget}
        >
          Send us feedback
        </a>
      </span>
    </div>
    <style jsx>{`
      /* Force a break clear across the document */
      .floatfollower {
        box-sizing: border-box;
        clear: both;
        width: 100%;
      }

      .feedback-footer {
        border-top: 1px solid ${theme.colors.gray4};
        padding-top: 1.5rem;
        margin-bottom: 3rem;
        display: flex;
        flex-wrap: wrap-reverse;
        justify-content: space-between;
      }

      .feedback-link {
        margin-right: 1em;
      }
    `}</style>
  </>
);

export default FeedbackFooter;
